import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';

function isEmpty(obj) { 
	for (const prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}
	return true;
}

function withDailybonus(WrappedComponent) {
	class WithDailyBonus extends React.Component {
		constructor(props) {
			super(props);
			this.onDailyBonuses = this.onDailyBonuses.bind(this);

			const queryString  = window.location.search;
			const urlParams    = new URLSearchParams(queryString);
			const date         = urlParams.get('qmdate');
		
			const stored = Flux.DailyBonus.getDailybonusFromStore(date);

			this.state = {
				date:         date,
				dailyBonuses: isEmpty(stored) ? null : stored,
			};
		}

		componentDidMount() {
			Flux.DailyBonus.addLoadedListener(this.onDailyBonuses);
			if (isEmpty(Flux.DailyBonus.getDailybonusFromStore(this.state.date))) {
				Flux.DailyBonus.getDailyBounesFromApi(this.state.date, this.onDailyBonuses);
			}
		}

		componentWillUnmount() {
			Flux.DailyBonus.removeLoadedListener(this.onDailyBonuses);
		}

		onDailyBonuses() {
			this.setState(state => ({
				dailyBonuses: Flux.DailyBonus.getDailybonusFromStore(state.date),
			}));
		}

		render() {
			return <WrappedComponent {...this.state} {...this.props} />;
		}
	}

	WithDailyBonus.propTypes = {
		location: PropTypes.shape({
			search: PropTypes.string,
		}),
	};

	WithDailyBonus.defaultProps = {
		location: null,
	};

	return WithDailyBonus;
}

export default withDailybonus;

